import React from "react";
import PropTypes from 'prop-types'
import Skeleton from "@material-ui/lab/Skeleton";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(() => ({
    questionWrapper: {
        display: 'flex',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
    },
    questionLabel: {
        flex: 1,
        padding: 5,
        borderRight: '1px solid rgba(0, 0, 0, 0.12)'
    },
    questionValue: {
        flex: 1,
        padding: 5,
        borderRight: '1px solid rgba(0, 0, 0, 0.12)'
    },
    questionWeight: {
        width: 40,
        padding: 5,
    },
}));

const SurveyQuestion = ({styles}) => {
    const classes = useStyles();
    return (
        <div
            style={{
                background: styles.background,
                padding: styles.padding
            }}
        >
            <div className={classes.questionWrapper}>
                <div className={classes.questionLabel}>
                    <Skeleton animation={false}/>
                </div>
                <div className={classes.questionValue}>
                    <Skeleton animation={false}/>
                </div>
                <div className={classes.questionWeight}>
                    <Skeleton animation={false}/>
                </div>
            </div>
        </div>
    )
};


export default SurveyQuestion

SurveyQuestion.propTypes = {
    surveyQuestion: PropTypes.object,
    path: PropTypes.string
};